<style lang="scss" scoped>


</style>

<template>
    <Modal ref="modal">
        <template v-slot:title>
            Lokale Niederschläge dokumentieren
        </template>
        
        <div class="alert alert-info mb-3" role="alert">
            <h4 class="alert-title">Wie werden die lokalen Niederschläge verteilt?</h4>
            <div class="text-muted">Die Zuteilung erfolgt im gewählten Messzeitraum auf Tagesbasis gemäß der relativen Verteilung der benachbarten Wetterstation.</div>
        </div>
        
       <div class="row mt-1 mb-2">
            <div class="col-12">
                <label class="form-label">Beginn des Zeitraums</label>
                <div class="input-icon mb-2">
                  <DatePickerInput ref="startDate" v-model:date="correction.startDate" :minDate="minDate" :maxDate="maxDate"></DatePickerInput>
                  <span class="input-icon-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><rect x="4" y="5" width="16" height="16" rx="2"></rect><line x1="16" y1="3" x2="16" y2="7"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="4" y1="11" x2="20" y2="11"></line><line x1="11" y1="15" x2="12" y2="15"></line><line x1="12" y1="15" x2="12" y2="18"></line></svg>
                  </span>
                </div>
            </div>     
       </div>
       <div class="row mt-1 mb-2">
            <div class="col-12">
                <label class="form-label">Ende des Zeitraums</label>
                <div class="input-icon mb-2">
                  <DatePickerInput ref="endDate" v-model:date="correction.endDate" :minDate="minDate" :maxDate="maxDate"></DatePickerInput>
                  <span class="input-icon-addon">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><rect x="4" y="5" width="16" height="16" rx="2"></rect><line x1="16" y1="3" x2="16" y2="7"></line><line x1="8" y1="3" x2="8" y2="7"></line><line x1="4" y1="11" x2="20" y2="11"></line><line x1="11" y1="15" x2="12" y2="15"></line><line x1="12" y1="15" x2="12" y2="18"></line></svg>
                  </span>
                </div>
            </div>     
       </div>
       
       <div class="row mt-1 mb-2">
            <div class="col-12">
                <label class="form-label">Niederschlagsmenge im Zeitraum in mm</label>
                <RangeSliderInput ref="precipitation" v-model:value="correction.precipitation"></RangeSliderInput>
            </div>     
       </div>          
       <template v-slot:footer>
            <button type="button" class="btn me-auto" @click="$refs.modal.closeModal">
                Abbrechen
            </button>
            <a href="#" class="btn btn-info ms-auto" @click="submit">
              <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                    <polyline points="7 11 12 16 17 11" />
                    <line x1="12" y1="4" x2="12" y2="16" />   
              </svg>
                Speichern 
            </a>
            
        </template>
    </Modal>
</template>

<script>

import * as dayjs from 'dayjs';
import MinMax from 'dayjs/plugin/minMax';
dayjs.extend(MinMax)

import Modal from '@/components/Modal.vue';
import DatePickerInput from '@/components/input/DatePickerInput.vue';
import RangeSliderInput from '@/components/input/RangeSliderInput.vue';

export default {
    name: 'Precipitation Alter Modal',
    components: {
        Modal,
        DatePickerInput,
        RangeSliderInput
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        correctionList: {
            type: Array,
            default: null
        }
    },
    data: function () {
        return {
            correction: {
                startDate: null,
                endDate: null,
                precipitation: 10
            },
            minDate: null,
            maxDate: null
        }
    },
    computed: {
        
    },
    methods: {
        openModal: function () {
            this.$refs.modal.openModal();            
        },
        submit: function () {
            this.$emit('submit', this.correction);
            this.$refs.modal.closeModal();            
        },
        getDefaultDate: function () {
            let date_today = this.makeDate(dayjs().format('DD.MM'));
            let date_list = this.getListMaxDate(this.correctionList);
                        
            if (date_list) {
                date_today = dayjs.max(
                    date_list.add(1, 'day'),
                    date_today.subtract(1, 'day')
                )
            }
                       
            return dayjs.min(
                date_today,
                this.makeDate('31.12')
            ).format('YYYY-MM-DD');
        },
        getMinDate: function () {
            let date_list = this.getListMaxDate(this.correctionList);
            
            if (date_list) {
               return dayjs.min(
                    date_list.add(1, 'day'),
                    this.makeDate('31.12')
               ).format('YYYY-MM-DD');
            }
            return this.makeDate('01.01').format('YYYY-MM-DD');
        },
        getMaxDate: function () {
            return this.makeDate('31.12').format('YYYY-MM-DD');
        },
        dateToISOString: function (date) {
            return date.toISOString().substring(0, 10);
        },
        makeDate: function (ds) {
            return dayjs('{}-{}-{}'.format(
                this.state.profile.year,
                parseInt(ds.split('.')[1]),
                parseInt(ds.split('.')[0])
            ));
        },
        getListMaxDate: function (list) {
            let self = this;
            
            if (list.length == 0 ) {
                return null;
            }
                        
            let max_item = list.reduce( function (a, b) {
                return self.makeDate(a.date) > self.makeDate(b.date)  ? a : b;
            })
            
            return self.makeDate(max_item.date);
        }
    },
    watch: {
        'correctionList': function () {
            this.correction.startDate = this.getDefaultDate();
            this.correction.endDate = this.getDefaultDate();
            
            this.minDate = this.getMinDate();
            this.maxDate = this.getMaxDate();
        },
        'correction.startDate': function () {
            let startDate = this.makeDate(dayjs(this.correction.startDate).format('DD.MM'));
            let endDate = this.makeDate(dayjs(this.correction.endDate).format('DD.MM'));
            
            if (startDate > endDate) {
                this.correction.endDate = startDate.format('YYYY-MM-DD');
            }
        },
        'correction.endDate': function () {
            let startDate = this.makeDate(dayjs(this.correction.startDate).format('DD.MM'));
            let endDate = this.makeDate(dayjs(this.correction.endDate).format('DD.MM'));
            
            if (startDate > endDate) {
                this.correction.startDate = endDate.format('YYYY-MM-DD');
            }
        }
    },
    created: function () {
        
    },
    mounted: function () {
    
    }
}
</script>